module.exports = __webpack_public_path__ + "static/media/ocd_thumb_wide.a87c2206.jpg";